<template>
    <div v-if="loading">
      <loader></loader>
    </div>
    <div v-else>
      <div class="form">
          <div class="form-group">
              <label for="name">Nome</label>
              <input id="name" class="form-control" v-model="newSection.name" placeholder="Nome">
          </div>
          <div class="form-group">
              <label for="description">Descrição</label>
              <textarea id="description" class="form-control" v-model="newSection.description"
                        placeholder="Descrição"></textarea>
          </div>
          <hr>
          <div class="form-group">
              <label for="description">Repetição</label>
              <p class="help-block">A seção pode se repetir?</p>
              <input id="repeat" type="checkbox" v-model="newSection.repeat.active"/>
          </div>
          <div v-show="newSection.repeat.active">
            <div class="form-group">
                <label for="repeatMin">Mínimo</label>
                <input id="repeatMin" type="number" class="form-control" v-model="newSection.repeat.min"/>
            </div>
            <div class="form-group">
                <label for="repeatMax">Máximo</label>
                <input id="repeatMax" type="number" class="form-control" v-model="newSection.repeat.max"/>
            </div>
          </div>
          <hr>
          <div class="form-group">
              <label for="description">Ação</label>
              <p class="help-block">Ação ao submeter dados da seção:</p>
              <select id="type" class="form-control" v-model="newSection.action" placeholder="Comportamento">
                  <option v-for="sectionAction in sectionActions" v-bind:value="sectionAction" :key="sectionAction.objectId">{{sectionAction}}</option>
              </select>
          </div>
          <div class="form-group" v-if="newSection.action === 'goto'">
            <multiselect v-model="newSection.goto" label="name" track-by="objectId" :options="sections" :showLabels=false placeholder="Selecione uma opção"></multiselect>
          </div>
        <button id="btn-save-field" type="button" class="btn btn-primary" @click="save">Salvar</button>
        <button type="button" class="btn btn-default" @click="cancel">Cancelar</button>
      </div>
      <br>
      <form-field-list v-bind:reqType='requestTypeId' v-bind:sectionId='sectionId' v-if='requestTypeId && sectionId'></form-field-list>
    </div>
</template>

<script>

import { Parse, miniToastr } from '../Global'
import Loader from './util/Loader'
import FormFieldList from './FormFieldList'
import Multiselect from 'vue-multiselect'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader,
    FormFieldList,
    Multiselect
  },
  data () {
    return {
      loading: false,
      show: false,
      newSection: { action: '', goto: {}, repeat: { active: false } },
      requestTypeId: '',
      sectionId: '',
      sectionActions: ['next', 'goto', 'end'],
      sections: []
    }
  },
  mounted () {
    this.sectionId = this.$route.params.id
    this.requestTypeId = this.$route.params.reqType
    if (this.sectionId) {
      this.getById(this.sectionId, this.requestTypeId)
    } else {
      this.getFormSections(this.requestTypeId)
    }
  },
  methods: {
    getById (id, requestTypeId) {
      let self = this
      self.loading = true
      let params = {
        formId: id,
        requestId: requestTypeId
      }
      Parse.Cloud.run('getFormSection', params).then(formSection => {
        self.newSection = formSection.toJSON()
        // Default values
        if (!this.newSection.action) {
          this.newSection.action = this.sectionActions[0]
        }
        self.loading = false
        return self.getFormSections(requestTypeId)
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    getFormSections (requestTypeId) {
      let self = this
      self.loading = true
      let params = {
        requestId: requestTypeId
      }
      return Parse.Cloud.run('listFormSections', params).then(results => {
        self.sections = results.data.map(r => r.toJSON())
        self.loading = false
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    save () {
      let self = this
      self.loading = true
      let params = {
        requestId: self.$route.params.reqType,
        sectionId: self.$route.params.id,
        sectionData: self.newSection
      }
      Parse.Cloud.run('saveFormSection', params).then(results => {
        miniToastr.success('Salvo com sucesso')
        self.loading = false
        self.$router.go(-1)
      }).fail(error => {
        handleParseError(self, error)
        self.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormSectionDetail.vue?42e0a8ef